import type React from "react";

import { useRoutes } from "react-router-dom";

import { Broadcast, Conversation, MessagesLayout } from "./components";

export const MessagesRoutes: React.FC = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <MessagesLayout />,
      children: [
        {
          path: "broadcast",
          element: <Broadcast />,
        },
        { path: "patients/:patientId", element: <Conversation /> },
      ],
    },
  ]);

  return routes;
};
